(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/password-recovery/components/recovery-email-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/password-recovery/components/recovery-email-form.js');
"use strict";


const {
  LOGIN
} = svs.ticket_partner.constants.routes;
const Email = svs.ui.reactFormInputs.EmailInput;
const {
  EMAIL_LABEL,
  EMAIL_MAX,
  EMAIL_REQUIRED_ERROR,
  EMAIL_NAME
} = svs.ticket_partner.passwordRecovery.constants.FORMS.EMAIL;
const {
  HEADER,
  RESTORE_OPTIONS
} = svs.ticket_partner.passwordRecovery.constants.FORMS;
const {
  passwordRecoveryErrorMapper,
  getAvailableDeliveryChannels
} = svs.ticket_partner.services;
const {
  showErrorDialog
} = svs.ticket_partner.utils;
const Button = svs.ui.ReactButton;
const {
  Form
} = svs.ui.reactForm;
const RecoveryEmailForm = _ref => {
  let {
    email,
    onEmailChange,
    onRestoreOptionsChange
  } = _ref;
  const {
    redirectToReturnUrl
  } = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(LOGIN);
  const onCancel = e => {
    e.preventDefault();
    redirectToReturnUrl();
  };
  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let {
        isValid
      } = _ref2;
      return !isValid;
    })) {
      return;
    }
    try {
      var _response$response;
      const response = await getAvailableDeliveryChannels(email);
      const options = [];
      const {
        sms,
        letter
      } = (response === null || response === void 0 || (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.deliveryChannels) || {};
      if (sms) {
        options.push(RESTORE_OPTIONS.SMS.value);
      }
      if (letter) {
        options.push(RESTORE_OPTIONS.LETTER.value);
      }
      onRestoreOptionsChange(options);
    } catch (error) {
      showErrorDialog(passwordRecoveryErrorMapper(error));
    }
  };
  return React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-bold"
  }, HEADER), React.createElement(Email, {
    errorMessageRequired: EMAIL_REQUIRED_ERROR,
    id: EMAIL_NAME,
    isRequired: true,
    label: EMAIL_LABEL,
    max: EMAIL_MAX,
    name: EMAIL_NAME,
    onChange: onEmailChange,
    value: email
  }), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Button, {
    className: "margin-right-1",
    onClick: onCancel,
    transparent: true
  }, "Avbryt"), React.createElement(Button, {
    inverted: true,
    type: "submit"
  }, "Forts\xE4tt")));
};
svs.ticket_partner.passwordRecovery.RecoveryEmailForm = RecoveryEmailForm;

 })(window);